import React from 'react'
import { CFView, ThemedText } from 'components'

export default ({ product, AddQuantityButton, SubtractQuantityButton }) => {
  const { name, price, count } = product
  return (
    <CFView column mb="20px">
      <CFView row justifyBetween>
        <CFView fill row alignStart>
          <ThemedText fill h5 bold textLeft mt="2px" ml="10px" mr="5px">
            {name}
          </ThemedText>
        </CFView>
        <CFView row alignStart>
          <ThemedText h5 bold mt="2px" ph="10px">
            {`$${price.toFixed(2)} `}
          </ThemedText>
          <CFView>{SubtractQuantityButton}</CFView>
          <CFView w="30px" center>
            <ThemedText h5 bold mt="2px" mh="5px">
              {count}
            </ThemedText>
          </CFView>
          <CFView>{AddQuantityButton}</CFView>
        </CFView>
      </CFView>
    </CFView>
  )
}
